import { Countries, FeatureFlags } from 'typings'
import * as actionTypes from './actionTypes'
import { StateType as LocalisationStateType } from './reducer'

export const toggleLID = () => ({
  type: actionTypes.TOGGLE_LID,
})

export const checkLocalisationUpdate = (
  country: string,
  flagUpdates: FeatureFlags,
  currentVersionString: string,
) => ({
  type: actionTypes.CHECK_LOCALISATION_UPDATE,
  payload: {
    country,
    flagUpdates,
    currentVersionString,
  },
})

export const updateLocalisations = (
  translations: LocalisationStateType['translations'],
) => ({
  type: actionTypes.UPDATE_LOCALISATIONS,
  payload: {
    translations,
  },
})

export const setLocalisations = (
  translations: LocalisationStateType['translations'],
) => ({
  type: actionTypes.SET_LOCALISATIONS,
  payload: {
    translations,
  },
})
